module.exports = __webpack_public_path__ + "b7b6f688344e63a647c4e588e7c140fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-screenshot.jpg
// module id = 2974
// module chunks = 0 1